// extracted by mini-css-extract-plugin
export var button = "header-module--button--4db39";
export var cover = "header-module--cover--84547";
export var dark = "header-module--dark--4d476";
export var header = "header-module--header--72976";
export var imageWrapper = "header-module--image-wrapper--3feb1";
export var inner = "header-module--inner--1853c";
export var innerWithImage = "header-module--inner-with-image--1e44a";
export var light = "header-module--light--2708f";
export var medium = "header-module--medium--f0833";
export var slope = "header-module--slope--aa29b";